const memberLevelOptions = [
  {
    value: 'network',
    label: 'Network Member',
    icon: 'graph_5',
    iconLibrary: 'material',
  },
  {
    value: 'community',
    label: 'Community Member',
    icon: 'graph_5',
    iconLibrary: 'material',
    hidden: true,
  },
  {
    value: 'contributor',
    label: 'Contributor Member',
    icon: 'communities',
    iconLibrary: 'material',
  },
  {
    value: 'foundation',
    label: 'Foundation Member',
    icon: 'foundation',
    iconLibrary: 'material',
  },
  {
    value: 'steward',
    label: 'Steward Member',
    icon: 'crowdsource',
    iconLibrary: 'material',
  },
];
const memberLevelMap = Object.fromEntries(memberLevelOptions.map((o) => [o.value, o]));


/*=== EXPORTS ===*/

export {
  memberLevelOptions,
  memberLevelMap,
};
